<template>
  <v-container grid-list-xl>
    <h1>Prüfung</h1>
    <v-stepper v-model="currentStep" vertical class="elevation-0" style="background: transparent;">
      <v-stepper-step step="1" :complete="currentStep > 1">
        Einstellungen
        <small>{{ selectedPruefungText }}</small>
      </v-stepper-step>
      <v-stepper-content step="1">
        <!-- <div> -->
        <!--   <v-select -->
        <!--     :items="verfahren" -->
        <!--     item-text="ID" -->
        <!--     item-value="ID" -->
        <!--     v-model="selectedVerfahren" -->
        <!--     label="Verfahren" -->
        <!--     ></v-select> -->
        <!--   <v-select -->
        <!--     :items="stufen" -->
        <!--     v-model="selectedStufe" -->
        <!--     label="Stufe" -->
        <!--     ></v-select> -->
        <!--   <v-select -->
        <!--     :items="sektoren" -->
        <!--     v-model="selectedSektor" -->
        <!--     label="Sektor" -->
        <!--     ></v-select> -->
        <!--   <v-select -->
        <!--     :items="standorte" -->
        <!--     :auto="true" -->
        <!--     item-text="Standort" -->
        <!--     v-model="selectedStandort" -->
        <!--     label="Ort" -->
        <!--     ></v-select> -->
        <!-- </div> -->
        <div>

      <v-data-table
        :loading="isLoading"
        :headers="pruefungHeaders"
        :items="pruefungen"
        no-data-text="Keine Prüfungen gefunden"
        hide-actions
        class="elevation-1"
        >
        <template slot="items" slot-scope="props">
          <tr @click="selectPruefung(props.item)">
          <td>{{ props.item.bezeichnung }}</td>
          <td>{{ props.item.ort }}</td>
          <td>{{ props.item.sektor }}</td>
          <td>{{ props.item.von }}</td>
          </tr>
        </template>
      </v-data-table>

          <!-- <table> -->
          <!-- <tbody> -->
          <!--   <tr v-for="item in pruefungen"> -->
          <!--     <td>{{ item.bezeichnung }}</td> -->
          <!--     <td>{{ item.ort }}</td> -->
          <!--     <td>{{ item.sektor }}</td> -->
          <!--     <td>{{ item.von }}</td> -->
          <!--   </tr> -->
          <!-- </tbody> -->
          <!-- </table> -->
        </div>
        <!-- <v-btn color="primary" @click="toStep2" :disabled="!canProceed(2)">Weiter</v-btn> -->
      </v-stepper-content>
      <v-stepper-step step="2" :complete="currentStep > 2">Prüfungsteile/-dokumente</v-stepper-step>
      <v-stepper-content step="2">
        <div v-if="sets.length > 0">
          <v-flex mb-5>
            <ul>
              <li v-for="set in sets" :key="set.ID">
                <v-layout row>
                  <v-flex xs3>
                    {{ set.Bezeichnung}}
                  </v-flex>
                  <v-flex xs3>
                  <ul style="list-style: none">
                    <li v-for="part in set.parts" :key="part.key">
                       <v-checkbox
                         :label="part.name"
                         :hideDetails="true"
                         v-model="selectedParts"
                         :value="part"
                         ></v-checkbox></li>
                  </ul>
                  </v-flex>
                </v-layout>
              </li>
            </ul>
          </v-flex>
          <v-btn color="primary" @click.native="currentStep = 3">Weiter</v-btn>
          <v-btn flat @click="restart">Abbrechen</v-btn>
        </div>
        <v-alert outline type="info" :value="sets.length === 0">
          Keine Prüfungssets gefunden
          <v-btn small flat @click="restart">Zurück</v-btn>
        </v-alert>
      </v-stepper-content>
      <v-stepper-step step="3" :complete="currentStep > 3">Prüfungsstücke</v-stepper-step>
      <v-stepper-content step="3">
        <v-card color="grey lighten-1" class="mb-5" height="200px"></v-card>
        <v-btn color="primary" @click.native="currentStep = 4">Weiter</v-btn>
        <v-btn flat>Abbrechen</v-btn>
      </v-stepper-content>
      <v-stepper-step step="4" :complete="currentStep > 4">Download</v-stepper-step>
      <v-stepper-content step="4">
        <v-btn color="primary">Download Prüfung</v-btn>
      </v-stepper-content>
    </v-stepper>
  </v-container>
</template>

<script>
import sortby from 'lodash.sortby';
export default {
  name: 'ExamMainPage',
  data() {
    return {
      isLoading: true,
      loadingProgress: 0,
      currentStep: 1,
      verfahren: [],
      standorte: [],
      pruefungen: [],
      pruefungHeaders: [
        { text: 'Bezeichnung', value: 'bezeichnung' },
        { text: 'Ort', value: 'ort' },
        { text: 'Sektor', value: 'sektor', sortable: true },
        { text: 'Datum', value: 'von', sortable: true }
      ],
      sektoren: 'c_f_w_t_wp_p'.split('_'),
      stufen: [1, 2, 3],
      sets: [],
      templateExamParts: ['L1', 'L2 - PA ergänzen', 'L2 - PA erstellen', 'L2 - Prüfen'],
      selectedVerfahren: null,
      selectedStufe: null,
      selectedStandort: null,
      selectedSektor: null,
      selectedPruefung: null,
      selectedParts: []
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      try {
        const [pruefungen, verfahren, standorte] = await Promise.all([
          this.$http.get('pruefung'),
          this.$http.get('verfahren'),
          this.$http.get('standort')
        ]);

        this.pruefungen = pruefungen.body;
        this.verfahren = verfahren.body;
        this.standorte = standorte.body;
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    async loadSets(pruefung) {
      try {
        this.isLoading = true;
        const sets = await this.$http.get(`pruefungsset?v=${pruefung.verfahren}`);

        var mySets = sets.body
          .map(m => {
            m.parts = this.templateExamParts.map((tep, i) => {
              return {
                key: `${m.ID}-${i + 1}`,
                name: tep,
                set: m
              };
            });
            return m;
          })
          .filter(
            f =>
              f.industriesektoren.filter(f2 => f2.Kürzel.toLowerCase() === pruefung.sektor).length >
              0
          );

        this.sets = sortby(mySets, 'Bezeichnung');
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    restart() {
      this.selectedPruefung = null;
      this.currentStep = 1;
    },
    selectPruefung(item) {
      this.selectedPruefung = item;
      this.toStep2();
    },
    canProceed(targetStep) {
      if (targetStep === 2) {
        return (
          this.selectedVerfahren !== null &&
          this.selectedStufe !== null &&
          this.selectedStandort !== null &&
          this.selectedSektor !== null
        );
      }

      return false;
    },
    toStep2() {
      this.loadSets(this.selectedPruefung).then(() => {
        this.currentStep = 2;
      });
    }
  },
  computed: {
    selectedStandortName() {
      if (this.selectedStandort) {
        return this.selectedStandort.Standort;
      }

      return 'Standort';
    },
    selectedPruefungText() {
      if (this.selectedPruefung) {
        return `${this.selectedPruefung.bezeichnung}`;
      }

      return 'Prüfung wählen';
    }
  }
};
</script>
